import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

const ITEMS_PER_PAGE = 'Items per page';

@Injectable()
export class MatPaginatorIntlFr extends MatPaginatorIntl {
     
    public constructor(private translate: TranslateService) {
        super();
      
        this.translate.onLangChange.subscribe(() => {
          this.getAndInitTranslations();
        });
      
        this.getAndInitTranslations();
      }

      public getAndInitTranslations(): void {
        this.translate.get([
          ITEMS_PER_PAGE      
        ])
          .subscribe((translation: any) => {
            this.itemsPerPageLabel = translation[ITEMS_PER_PAGE];         
            this.changes.next();
          });
      }

      getRangeLabel = function (page, pageSize, length) {
        const of = this.translate ? this.translate.instant('paginator.of') : 'of';
        if (length === 0 || pageSize === 0) {
          return '0 ' + of + ' ' + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
          Math.min(startIndex + pageSize, length) :
          startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
      };
    
    }  